// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import './_collection-preview.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--collection-preview").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("collection-preview-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.collection-preview').find(".swiper-button-prev").addClass("collection-preview-btn-prev-" + index);
        $this.parents('.collection-preview').find(".swiper-button-next").addClass("collection-preview-btn-next-" + index);

        var swiper = new Swiper(".collection-preview-instance-" + index, {
            // Optional parameters
            modules: [Navigation, A11y],
            slidesPerView: 2,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 2,
                    spaceBetween: 25
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 25
                }
            },

            // // Navigation arrows
            navigation: {
              nextEl: ".collection-preview-btn-next-" + index,
              prevEl: ".collection-preview-btn-prev-" + index
            }
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })

            /**
             * Once we move to "card--product-with-add-to-cart", you can remove the guard.
             */
            let slideAddToCart = slide.querySelector('.card__product-add-to-cart');
            if (slideAddToCart) {
                slideAddToCart.addEventListener('focus', function(e) {
                    swiper.slideTo(index);
                })
            }
        });
    });
});
